<div class="pos-picker-before"></div>
<div class="pos-picker-select"></div>
<div class="pos-picker-columns">
  <pos-picker-column [col]="colHours" (posPickerColChange)="handleHoursColChange($event)"></pos-picker-column>
  <div class="time-picker-suffix">:</div>
  <pos-picker-column [col]="colMinute" (posPickerColChange)="handleMinutesColChange($event)"></pos-picker-column>
</div>
<div class="pos-picker-after"></div>
